import { render, staticRenderFns } from "./OptionsInfo.vue?vue&type=template&id=6e04b064"
import script from "./OptionsInfo.vue?vue&type=script&lang=js"
export * from "./OptionsInfo.vue?vue&type=script&lang=js"
import style0 from "./OptionsInfo.vue?vue&type=style&index=0&id=6e04b064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports